import { render, staticRenderFns } from "./StuffListForStoreView.vue?vue&type=template&id=84de88d2"
import script from "./StuffListForStoreView.vue?vue&type=script&lang=js"
export * from "./StuffListForStoreView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports